export default [
    {
        path: '/modulos',
        meta: { nombre: 'Modulos' },
        name: 'modulos',
        component: () => import(/* webpackChunkName: "modulos" */ '../../pages/modulos').then(m => m.default || m)
    }
]
